import { TileLayer } from 'react-leaflet';
import { useMapProvider } from '@/hooks/useMapProvider';

/**
 * A TileLayer component that automatically uses the user's selected map provider.
 * Drop-in replacement for react-leaflet's TileLayer.
 */
export default function DynamicTileLayer({ ...props }) {
  const { tileConfig } = useMapProvider();

  return (
    <TileLayer
      url={tileConfig.url}
      attribution={tileConfig.attribution}
      subdomains={tileConfig.subdomains}
      maxZoom={19}
      {...props}
    />
  );
}
